(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2761],{

/***/ 14091:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/departures",
      function () {
        return __webpack_require__(60297);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/BreadCrumbs/breadCrumbs.module.sass
var breadCrumbs_module = __webpack_require__(75685);
var breadCrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadCrumbs_module);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/BreadCrumbs/BreadCrumbs.jsx







var BreadCrumbs = function(param) {
    var routeCrumbs = param.routeCrumbs, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadCrumbs_module_default()).wrapper,
        itemScope: true,
        itemType: "https://schema.org/BreadcrumbList",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (breadCrumbs_module_default()).overflowWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (breadCrumbs_module_default()).crumb,
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        itemProp: "name",
                        className: (0,classcat/* default */.Z)([
                            (breadCrumbs_module_default()).home,
                            (0,_define_property/* default */.Z)({}, (breadCrumbs_module_default()).homeBf, url === "black_friday"), 
                        ]),
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/bfHomePage",
                                width: 10,
                                height: 10
                            }),
                            itemProp: "item"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/HomePage",
                                width: 16,
                                height: 16
                            }),
                            itemProp: "item"
                        })
                    })
                }),
                routeCrumbs.map(function(i, id) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: "https://schema.org/ListItem",
                        className: (breadCrumbs_module_default()).point,
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).currentBf : (breadCrumbs_module_default()).activeBf,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).current : (breadCrumbs_module_default()).active,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        })
                    }, id);
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/BreadCrumbs/index.js



/***/ }),

/***/ 94925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ EmptySearch; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/SearchCruises/EmptySearch/emptySearch.module.sass
var emptySearch_module = __webpack_require__(75949);
var emptySearch_module_default = /*#__PURE__*/__webpack_require__.n(emptySearch_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/SearchCruises/EmptySearch/EmptySearch.jsx






var EmptySearch = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (emptySearch_module_default()).emptySearch,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (emptySearch_module_default()).emptySearchIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                            name: "common/EmptyDate",
                            width: 48,
                            height: 48
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (emptySearch_module_default()).emptySearchDescription,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        variant: "heading-8",
                        children: "По выбранным параметрам отправлений нет, попробуйте изменить фильтр или дату."
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/SearchCruises/EmptySearch/index.js



/***/ }),

/***/ 60297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ DeparturesPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(46670);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next-useragent/dist/next-useragent.js
var next_useragent = __webpack_require__(28010);
// EXTERNAL MODULE: ./node_modules/react-if/dist/react-if.esm.js
var react_if_esm = __webpack_require__(34394);
// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
// EXTERNAL MODULE: ./components/Layout/index.js + 6 modules
var Layout = __webpack_require__(82913);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/esm/index.js + 28 modules
var esm = __webpack_require__(11289);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(69293);
// EXTERNAL MODULE: ./components/DeparturesPage/SearchDepartures/searchdepartures.module.sass
var searchdepartures_module = __webpack_require__(3938);
var searchdepartures_module_default = /*#__PURE__*/__webpack_require__.n(searchdepartures_module);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./components/SearchCity/index.js + 1 modules
var SearchCity = __webpack_require__(22563);
;// CONCATENATED MODULE: ./components/DeparturesPage/SearchDepartures/SearchDepartures.jsx


















var DateFormat = "YYYY-MM-DD";
var plusUnitToDate = function() {
    var day = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return dayjs_min_default()().add(day, "day").format(DateFormat);
};
var dates = [
    {
        name: "today",
        title: "Сегодня, ".concat(dayjs_min_default()().format("D MMMM")),
        value: plusUnitToDate()
    },
    {
        name: "tomorrow",
        title: "Завтра",
        value: plusUnitToDate(1)
    },
    {
        name: "day-after-tomorrow",
        title: "Послезавтра",
        value: plusUnitToDate(2)
    }, 
];
// const checkIsCustomDate = d => !dates.some(i => i.value === d);
var UpdateList = function() {
    var ref = (0,formik_esm/* useFormikContext */.u6)(), values = ref.values, submitForm = ref.submitForm;
    var store = (0,RootStoreProvider/* useDeparturesStore */.mz)();
    var filter = function(c, s) {
        return store.filterByCityAndShip(c, s);
    };
    (0,react.useEffect)(function() {
        filter(values.selectedCities, values.selectedShips);
    }, [
        values.selectedCities,
        values.selectedShips,
        submitForm
    ]);
    return null;
};
var SearchDepartures = (0,es/* observer */.Pi)(function(_param) {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var ref = (0,react.useState)(false), isOpenCalendar = ref[0], setIsOpenCalendar = ref[1];
    var actionsWrapperRef = (0,react.useRef)();
    var store = (0,RootStoreProvider/* useDeparturesStore */.mz)();
    var cities = store.cities, ships = store.ships, timeTable = store.timeTable;
    var ref1 = (0,react.useState)("today"), activeButton = ref1[0], setActiveButton = ref1[1];
    var fetchData = function(d) {
        return store.fetchByDate(d);
    };
    var filterCities = function(selectedShips) {
        return selectedShips.length === 0 ? cities : timeTable.filter(function(item) {
            return selectedShips.includes(item.t_title);
        }).map(function(item) {
            return item.route_start;
        }).filter(function(item, index, arr) {
            return arr.indexOf(item) === index;
        });
    };
    var filterShips = function(selectedCities) {
        return selectedCities.length === 0 ? ships : timeTable.filter(function(item) {
            return selectedCities.includes(item.route_start);
        }).map(function(item) {
            return item.t_title;
        }).filter(function(item, index, arr) {
            return arr.indexOf(item) === index;
        });
    };
    (0,useClickAway/* default */.Z)(actionsWrapperRef, function() {
        return setIsOpenCalendar(false);
    });
    var btn = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,classcat/* default */.Z)([
            (searchdepartures_module_default()).arrow
        ])
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,classcat/* default */.Z)([
            (searchdepartures_module_default()).wrapper,
            (0,_define_property/* default */.Z)({}, className, !!className)
        ])
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
            initialValues: {
                selectedCities: [],
                selectedShips: [],
                date: dayjs_min_default()().format("YYYY-MM-DD"),
                cities: cities,
                ships: ships
            },
            children: function(param) {
                var values = param.values, setFieldValue = param.setFieldValue, resetForm = param.resetForm;
                var calendar = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                    className: (0,classcat/* default */.Z)([
                        "departures-calendar"
                    ]),
                    prevLabel: btn,
                    nextLabel: btn,
                    locale: "ru-RU",
                    value: new Date(values.date),
                    onChange: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(date) {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        setFieldValue("date", dayjs_min_default()(date).format(DateFormat));
                                        setIsOpenCalendar(false);
                                        _ctx.next = 4;
                                        return fetchData(dayjs_min_default()(date).format(DateFormat));
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(date) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateList, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (searchdepartures_module_default()).top,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCity/* SearchCity */.u, {
                                    id: "selectedCities",
                                    label: "Город отправления",
                                    cities: filterCities(values.selectedShips),
                                    value: values.selectedCities
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCity/* SearchCity */.u, {
                                    id: "selectedShips",
                                    label: "Название теплохода",
                                    cities: filterShips(values.selectedCities),
                                    value: values.selectedShips
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            ref: actionsWrapperRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (searchdepartures_module_default()).actions,
                                    children: [
                                        dates.map(function(param) {
                                            var name = param.name, title = param.title, value = param.value;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                size: "sm",
                                                view: "white",
                                                onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                resetForm();
                                                                setFieldValue("date", value);
                                                                setActiveButton(name);
                                                                setIsOpenCalendar(false);
                                                                _ctx.next = 6;
                                                                return fetchData(value);
                                                            case 6:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                })),
                                                className: activeButton === name ? (searchdepartures_module_default()).active : "",
                                                children: title
                                            }, title);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (searchdepartures_module_default()).relative,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    className: activeButton === "custom-date" ? (searchdepartures_module_default()).active : "",
                                                    view: "white",
                                                    size: "sm",
                                                    onClick: function() {
                                                        setIsOpenCalendar(!isOpenCalendar);
                                                        setActiveButton("custom-date");
                                                    },
                                                    children: activeButton === "custom-date" ? dayjs_min_default()(values.date, DateFormat).format("D MMMM YYYY") : "Своя дата"
                                                }),
                                                isOpenCalendar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,classcat/* default */.Z)([
                                                        (searchdepartures_module_default()).calendar,
                                                        (0,_define_property/* default */.Z)({}, (searchdepartures_module_default()).active, isOpenCalendar), 
                                                    ]),
                                                    children: calendar
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isOpenCalendar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,classcat/* default */.Z)([
                                        (searchdepartures_module_default()).calendar,
                                        (searchdepartures_module_default()).mobile,
                                        (0,_define_property/* default */.Z)({}, (searchdepartures_module_default()).active, isOpenCalendar), 
                                    ]),
                                    children: calendar
                                })
                            ]
                        })
                    ]
                });
            }
        })
    }));
});

;// CONCATENATED MODULE: ./components/DeparturesPage/SearchDepartures/index.js


// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./styles/departuresPage.module.sass
var departuresPage_module = __webpack_require__(49014);
var departuresPage_module_default = /*#__PURE__*/__webpack_require__.n(departuresPage_module);
// EXTERNAL MODULE: ./components/Administration/Table/table.module.sass
var table_module = __webpack_require__(75930);
var table_module_default = /*#__PURE__*/__webpack_require__.n(table_module);
// EXTERNAL MODULE: ./node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(24561);
;// CONCATENATED MODULE: ./components/Skeleton/SkeletonTable.jsx





var SkeletonTable = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_content_loader_es/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        speed: 2,
        width: "100%",
        height: 78,
        viewBox: "0 0 100 78",
        backgroundColor: "#f3f3f3",
        foregroundColor: "#ecebeb",
        preserveAspectRatio: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            x: "0",
            y: "0",
            rx: "0",
            ry: "0",
            width: "100%",
            height: "78"
        })
    }));
};
var SkeletonList = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_content_loader_es/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        speed: 2,
        width: "100%",
        height: 256,
        viewBox: "0 0 100 256",
        backgroundColor: "#f3f3f3",
        foregroundColor: "#ecebeb",
        preserveAspectRatio: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            x: "0",
            y: "0",
            rx: "0",
            ry: "0",
            width: "100%",
            height: "256"
        })
    }));
};

// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/Administration/Table/Table.jsx














var Table = (0,es/* observer */.Pi)(function(param) {
    var view = param.view, className = param.className, grid = param.grid, headers = param.headers, items = param.items, loading = param.loading, transfer = param.transfer, isMobile = param.isMobile;
    // Helper для передачи grid разметки во все <tr>
    var Tr = function(_param) /*#__PURE__*/ {
        var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
            "children"
        ]);
        return (0,jsx_runtime.jsx)("tr", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            style: {
                gridTemplateColumns: grid
            }
        }, props), {
            children: children
        }));
    };
    var authStore = (0,RootStoreProvider/* useAuthStore */.tN)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        className: (0,classcat/* default */.Z)([
            (table_module_default()).table,
            (table_module_default())[view],
            (0,_define_property/* default */.Z)({}, className, !!className), 
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                className: (table_module_default()).head,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr, {
                    children: [
                        headers === null || headers === void 0 ? void 0 : headers.map(function(param) {
                            var title = param.title, note = param.note;
                            return title !== "id" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                children: [
                                    title,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (table_module_default()).subtitle,
                                        children: note
                                    })
                                ]
                            }, title) : null;
                        }),
                        authStore.isManager && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                className: (table_module_default()).body,
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (table_module_default()).skeletons,
                        children: new Array(10).fill(null).map(function(_, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonTable, {}, idx);
                        })
                    }),
                    !loading && items && items.length > 0 && items.map(function(i, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tr, {
                            children: i.map(function(j, id) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    className: (table_module_default()).between,
                                    children: [
                                        j !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (table_module_default()).tableRow,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm.If, {
                                                    condition: j !== i[4],
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                                                        children: j || "—"
                                                    })
                                                }),
                                                transfer[idx][id] !== 0 && transfer[idx][4] !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (table_module_default()).tableTransfer,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm.If, {
                                                        condition: j !== i[4] && transfer[idx][4] !== 0,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                                                            children: transfer[idx][id]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm.If, {
                                            condition: j === i[4] && j !== 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                                                children: authStore.isManager && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/adm_n/index.html#!/cruises/".concat(i[4]),
                                                    className: (table_module_default()).button,
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                            name: "common/edit",
                                                            width: 16,
                                                            height: 16
                                                        }),
                                                        width: 16,
                                                        height: 16
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }, "".concat(j, "_").concat(idx));
                            })
                        }, idx);
                    })
                ]
            })
        ]
    });
});
Table.defaultProps = {
    view: "main"
};

;// CONCATENATED MODULE: ./components/Administration/Table/index.js


// EXTERNAL MODULE: ./components/SearchCruises/EmptySearch/index.js + 1 modules
var EmptySearch = __webpack_require__(94925);
// EXTERNAL MODULE: ./components/DeparturesPage/List/list.module.sass
var list_module = __webpack_require__(58430);
var list_module_default = /*#__PURE__*/__webpack_require__.n(list_module);
;// CONCATENATED MODULE: ./components/DeparturesPage/List/List.jsx









var ListElement = function(param) {
    var headers = param.headers, items = param.items, isMobile = param.isMobile;
    var authStore = (0,RootStoreProvider/* useAuthStore */.tN)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (list_module_default()).item,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: items.map(function(i, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: headers[idx].title !== "id" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    headers[idx].title,
                                    " ",
                                    headers[idx].title === "Отправление" && "(По Москве)"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: i || "—"
                            })
                        ]
                    }) : authStore.isManager && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/adm_n/index.html#!/cruises/".concat(i[4]),
                        className: (list_module_default()).button,
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                    name: "common/edit",
                                    width: 16,
                                    height: 16
                                })
                            })
                        })
                    })
                }, "".concat(i, "_").concat(idx));
            })
        })
    });
};
var List = function(param) {
    var className = param.className, items = param.items, headers = param.headers, loading = param.loading, isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classcat/* default */.Z)((0,_define_property/* default */.Z)({}, className, !!className)),
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).skeletons,
                children: new Array(4).fill(null).map(function(_, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonList, {}, idx);
                })
            }),
            !loading && items && items.length > 0 && items.map(function(i, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListElement, {
                    headers: headers,
                    items: i,
                    isMobile: isMobile
                }, idx);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/DeparturesPage/List/index.js


// EXTERNAL MODULE: ./providers/SearchStoreProvider.tsx + 5 modules
var SearchStoreProvider = __webpack_require__(27101);
// EXTERNAL MODULE: ./components/BreadCrumbs/index.js + 1 modules
var BreadCrumbs = __webpack_require__(24277);
;// CONCATENATED MODULE: ./pages/departures.jsx
















// import { SubscribeForm } from '../components/Layout/components/Footer/Footer';
var PageContent = (0,es/* observer */.Pi)(function(param) {
    var isMobile = param.isMobile;
    var ref;
    var store = (0,RootStoreProvider/* useDeparturesStore */.mz)();
    var authStore = (0,RootStoreProvider/* useAuthStore */.tN)();
    react.useEffect(function() {
        store.fetchByDate(plusUnitToDate());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDepartures, {
                className: (departuresPage_module_default()).search
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm.If, {
                condition: (store === null || store === void 0 ? void 0 : (ref = store.tableItems) === null || ref === void 0 ? void 0 : ref.length) > 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm/* Then */.Zf, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
                                className: (departuresPage_module_default()).table,
                                headers: store.headers,
                                items: store.tableItems,
                                loading: store.loading,
                                grid: authStore.isManager ? "repeat(4, 1fr) 72px" : "repeat(4, 1fr)",
                                transfer: store.transferItems,
                                isMobile: isMobile
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                className: (departuresPage_module_default()).list,
                                headers: store.headers,
                                items: store.tableItems,
                                loading: store.loading,
                                isMobile: isMobile
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Else */.Ot, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySearch/* EmptySearch */.c, {})
                    })
                ]
            })
        ]
    });
});
var __N_SSP = true;
function DeparturesPage(param) {
    var uaString = param.uaString, _store = param.store, user = _store.user, popularPopdirs = _store.popularPopdirs, canonicalUrl = param.canonicalUrl;
    var ua = (0,next_useragent/* useUserAgent */.FS)(uaString || window.navigator.userAgent);
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    var pageRoute = [
        {
            title: "Онлайн-табло отправлений",
            link: ""
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStoreProvider/* SearchStoreProvider */.YG, {
        hydrationData: {
            user: user
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStoreProvider/* RootStoreProvider */.LD, {
            hydrationData: {
                user: user
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    title: "Онлайн-табло отправлений",
                    description: "Онлайн-табло отправлений",
                    additionalLinkTags: [
                        {
                            rel: "shortcut icon",
                            href: "/favicon.ico?v=2"
                        }, 
                    ],
                    canonical: canonicalUrl
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
                    isMobile: isMobile,
                    isTablet: isTablet,
                    emailMetrik: "online_tablo_departures_subscribe_email",
                    popularPopdirs: popularPopdirs,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container--block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* BreadCrumbs */.b, {
                                    routeCrumbs: pageRoute
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: (departuresPage_module_default()).title,
                                component: "h1",
                                variant: isMobile ? "heading-4" : "heading-1",
                                children: "Онлайн-табло отправлений"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContent, {
                                isMobile: isMobile
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 75930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__8Qc22","head":"table_head__Jvkc_","body":"table_body__vlODz","black":"table_black__ocMHP","between":"table_between__GtMm_","gray":"table_gray__8mZt3","skeletons":"table_skeletons__qO_Y0","tableTransfer":"table_tableTransfer__D_XuF","main":"table_main__VEiYu","admin":"table_admin__WRpiP","button":"table_button__osaA_","subtitle":"table_subtitle__94dm8"};

/***/ }),

/***/ 75685:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadCrumbs_wrapper__GujyW","overflowWrapper":"breadCrumbs_overflowWrapper__O0aFR","point":"breadCrumbs_point___AwGt","current":"breadCrumbs_current__uks0O","currentBf":"breadCrumbs_currentBf__aXcqk","active":"breadCrumbs_active__ExqTi","activeBf":"breadCrumbs_activeBf__8B_QV","crumb":"breadCrumbs_crumb__8cnCn","home":"breadCrumbs_home__ahfAn","homeBf":"breadCrumbs_homeBf__oorFp"};

/***/ }),

/***/ 58430:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"list_item__kznSM","skeletons":"list_skeletons__oBcTs","button":"list_button__rlof5"};

/***/ }),

/***/ 3938:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"searchdepartures_wrapper__C_6nl","top":"searchdepartures_top__IyUlr","btn":"searchdepartures_btn__SFpai","actions":"searchdepartures_actions__DiLNk","active":"searchdepartures_active___CYXJ","relative":"searchdepartures_relative__k6wAh","calendar":"searchdepartures_calendar__X6rru","mobile":"searchdepartures_mobile__KpfGR","arrow":"searchdepartures_arrow__Rhywj"};

/***/ }),

/***/ 75949:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"emptySearch":"emptySearch_emptySearch__bZYoo","emptySearchIcon":"emptySearch_emptySearchIcon__MJDnD","emptySearchDescription":"emptySearch_emptySearchDescription__dD2Df"};

/***/ }),

/***/ 49014:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"departuresPage_title__l4niu","search":"departuresPage_search__m41DG","table":"departuresPage_table__FDHUM","list":"departuresPage_list__aSYme"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(14091); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);